import { Box, Chip, Typography } from '@mui/material'

// ==================== SummaryBadge ====================
// A label + value chip used in the country accordion summary row.
const SummaryBadge = ({ label, value, bgColor }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
    <Typography
      sx={{ fontSize: 'var(--font-size-sm)', color: 'var(--forbrand-primary)' }}
    >
      {label}
    </Typography>
    <Chip
      label={value}
      size="small"
      sx={{
        fontWeight: 700,
        fontSize: 'var(--font-size-xs)',
        backgroundColor: bgColor,
        color: 'var(--forbrand-primary)',
        height: '28px',
        minWidth: '32px',
        borderRadius: 0,
      }}
    />
  </Box>
)

export default SummaryBadge
